"use strict";
const UserFeedback = require("../UserFeedbackComponent");
class RootUserFeedback extends UserFeedback {
    constructor() {
        super();
    }
    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /* START STEVE ADD-ON METHODS              */
    /*******************************************/
    initialize(/*steve,addOnOptions*/) {
        document.body.appendChild(this.renderer.rootElement);
    }
    startUp(/*steve,addOnOptions*/) {}
    /*******************************************/
    /* END STEVE ADD-ON METHODS                */
    /*******************************************/
}
module.exports = RootUserFeedback;
module.exports.$inject = [];
